import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, /* @__PURE__ */ e.createElement("path", { d: "m50.67 17.093-3.76-3.76L32.002 28.24 17.096 13.333l-3.76 3.76L28.243 32 13.336 46.907l3.76 3.76L32.003 35.76l14.906 14.907 3.76-3.76L35.763 32z" }));
export {
  l as default
};
